import Header from "components/Headers/Header";
import React, { useEffect, useState } from "react";
import { Col, Container, Form, Modal, Row, Table } from "reactstrap";
import Logo from "../../assets/img/brand/instructionLogo.png";

import instruction from "../../assets/img/custom/GRAPHIC_INSTRUCT_ATHLETE_ABOUT_SCHOOL_IP_CONTRACT.png";
import { Link } from "react-router-dom/cjs/react-router-dom";
import { tableData } from "context";
const InstructionsReadFirst = () => {
  const [showInstruction, setShowInstruction] = useState(false);
  const showInstructionToggle = () => {
    setShowInstruction(!showInstruction);
  };
  useEffect(() => {
    showInstructionToggle();
  }, []);

  return (
    <>
      <Header />
      <Container className="px-2 px-sm-5">
        <div className="d-flex justify-content-between align-items-center mb-1">
          <div className="ml-2 ml-sm-5">
            <a href="https://youtu.be/eGqO7ElIS9E" target="_blank">
              <button className="btn btn-danger rounded media-btn">
                <div> Viewpoint</div>
                <div>
                  <i className="fas fa-play fa-lg"></i>
                </div>
                <div>Video1</div>
              </button>
            </a>
          </div>
        </div>

        <div className="table-responsive">
          <Table>
            <thead>
              <tr className="bg-primary text-white text-center w-100">
                <th> </th>
                <th>STUDENT ATHLETES</th>
                <th> </th>
              </tr>
              <tr>
                <th className="bg-primary text-white">
                  <span className="text-capitalize text-underline">
                    What you can do here
                  </span>
                </th>
                <th className="bg-table-color text-center">
                  <span className="text-capitalize text-underline">How</span>
                </th>
                <th className="bg-table-color text-center">
                  <span className="text-capitalize text-underline">Why</span>
                </th>
              </tr>
            </thead>
            <tbody>
              {tableData?.map((item, index) => (
                <tr key={index}>
                  <td className="text-white bg-primary">{item.action}</td>
                  <td
                    className={`bg-table-color text-center ${
                      index % 2 === 1 ? "bg-table-color" : ""
                    }`}
                  >
                    {item.method}
                  </td>
                  <td
                    className={`bg-table-color text-center ${
                      index % 2 === 1 ? "bg-table-color" : ""
                    }`}
                  >
                    {item.reason}
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        </div>
        <h2 className="text-center txtClr mt-3">
          <b>To all Amateur Athletes, we at</b>
        </h2>
        <div className="d-flex justify-content-center">
          <img
            className="mx-2"
            alt={Logo}
            src={Logo}
            height="20px"
            width="200px"
          />
        </div>
        <h3 className="text-center txtClr">
          <b>say to you </b>
        </h3>
        <h1 className="text-center txtClr mt-2">
          <b>
            ‘We’re Here to HELP YOU’
            <br />
            ‘Feel free to give us your suggestions!’
          </b>
        </h1>
        <h3 className="text-center txtClr mt-2">
          <b>(EMAIL: FansHelpPlayers@gmail.com)</b>
        </h3>
        <Row>
          <Col
            sm="2"
            className="d-flex align-items-center justify-content-center"
          >
            <h1>Take Survey?</h1>
          </Col>
          <Col sm="10">
            <h3 className="text-center txtClr mt-3">
              <b>
                Hey Athletes-We are planning a sports analysis video database
                where coaches comment on game strategy and give their insights.
                Fans and Athletes will have free access. Click{" "}
                <a
                  href="https://fhp-coach-platform.web.app/auth/info"
                  target="_blank"
                >
                  here
                </a>{" "}
                to give your input.
              </b>
            </h3>
          </Col>
        </Row>
      </Container>
      <Modal isOpen={showInstruction} size="lg">
        <Container>
          <div className="d-flex pr-2 pt-4  ">
            <i
              className="fa fa-times pointer ml-auto text-danger"
              onClick={showInstructionToggle}
            ></i>
          </div>{" "}
          <h3 className="my-2 text-center">
            Click{" "}
            <Link to="/search-school-contract">
              <span className="text-underline text-primary pointer">here</span>{" "}
            </Link>
            to verify if your school has an Ip contract with us for you to use
          </h3>
          <div className="text-center mt-2 mb-2">
            <img src={instruction} alt="image" className="img-fluid" />
          </div>
        </Container>
      </Modal>
    </>
  );
};

export default InstructionsReadFirst;
